<style scoped lang="less">
  .dialog-container {
    z-index: 20;
    position: fixed;
    background-color: rgba(0,0,0,0.3);
    top:0;
    left:0;
    width:100%;
    height:100%;
  }
  .dialog-background {
    background-color: rgba(0,0,0,.3);
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .closeIcon {
    position: absolute;
    right: 8px;
    top: 3px;
    font-size:1.6rem;
    cursor: pointer;
  }
  .dialog-header {
    border-top-right-radius:10px;
    border-top-left-radius:10px;
    box-shadow: 0px 1px 3px -1px rgba(0, 0, 0, 0.2), 0px 1px 3px 2px rgba(0, 0, 0, 0.14), 0px 1px 12px 0px rgba(0, 0, 0, 0.12);
  }
  .headerText {
    font-size:1.3rem;
    font-weight: bold;
    color: #454545;
    padding-left:20px;
    width: 90%;
  }
  .dialog-footer {
    .button {
      margin-top: 5px !important;
    }
    padding: 20px;
    display: flex;
    justify-content: space-between;
  }
  .dialog-body {
    max-height: 75vh;
    overflow: auto;
    padding: 15px;
  }
  .dialog-card {
    border-radius: 10px;
    position: absolute;
    background: #fff;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    box-shadow: 0 0 6px rgba(0,0,0,.4);
  }

  @media screen and (max-width: 767px) {
    .dialog-container {
      top: 50px;
      height: calc(100vh - 44px);
    }
    .dialog-body {
      max-height: 78vh;
      overflow: auto;
      padding: 15px;
    }
    .dialog-card {
      border-radius:0;
      min-width: 100% !important;
      max-width: 100% !important;
      left: 0;
      top: 0;
      transform: none;
    }
    @media screen and (max-width: 1023px) {
      .dialog-container {
        max-height: 20vh;
      }
    }
    @supports (-webkit-overflow-scrolling: touch) {
      .dialog-body {
        max-height: 66vh;
      }
    }
  }
</style>
<template>
  <div
    v-if="isVisible"
    class="dialog-container"
  >
    <div
      class="dialog-background"
      @click="cancelButtonClicked"
    />
    <div class="dialog-card">
      <div class="dialog-header">
        <div class="headerText">
          {{ headerText }}
        </div>
        <div
          class="closeIcon fas fa-close"
          @click="cancelButtonClicked"
        />
      </div>
      <div class="dialog-body">
        <slot />
      </div>
      <div class="dialog-footer">
        <a
          v-if="cancelButton"
          class="cancel-button button button-tools is-mobile"
          @click="cancelButtonClicked"
        >{{ cancelButtonText }}</a>
        <a
          v-if="okButton"
          class="ok-button button button-tools is-mobile"
          @click="okButtonClicked"
        >{{ okButtonText }}</a>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ModalDialog',
    components: {
    },
    props: {
      visible: {
        default: false
      },
      headerText: {
        type: String
      },
      closeIcon: {
        type: Boolean,
        default: true
      },
      cancelButton: {
        type: Boolean,
        default: true
      },
      cancelButtonText: {
        type: String,
        default: 'Cancel'
      },
      okButton: {
        type: Boolean,
        default: true
      },
      okButtonText: {
        type: String,
        default: 'Ok'
      }
    },
    data() {
      return {
        isVisible: false
      }
    },
    updated() {
      this.$nextTick(function () {
        this.$emit('isVisible')
      })
    },
    mounted: function () {
      if (this.visible === true || this.visible) {
        this.show()
      }
      this.$nextTick(function () {
        this.$emit('isVisible')
      })
    },
    methods: {
      show() {
        document.documentElement.style.overflow = 'hidden'
        this.isVisible = true
      },
      hide() {
        document.documentElement.style.overflow = 'auto'
        this.isVisible = false
      },
      okButtonClicked() {
        this.hide()
        this.$emit('ok-button-clicked')
      },
      cancelButtonClicked() {
        this.hide()
        this.$emit('cancel-button-clicked')
      }
    }
  }
</script>
